'use client';

import Link from 'next/link';
import type { Route } from 'next';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="mt-8 border-t border-[hsl(var(--border))] py-12">
      <div className="container flex flex-wrap items-center justify-between gap-4">
        <div className="font-semibold text-sm">
          {t('Footer.copy', {
            year: currentYear,
            defaultValue: '© {{year}} Reparoly — Desarrollado por Iktan Consulting',
          })}
        </div>
        <div className="flex flex-wrap items-center gap-4">
          <Link href={'/terms' as Route}>
            {t('Footer.link-terms', { defaultValue: 'Términos' })}
          </Link>
          <Link href={'/privacy' as Route}>
            {t('Footer.link-privacy', { defaultValue: 'Privacidad' })}
          </Link>
          <a href="mailto:hola@reparoly.com">
            {t('Footer.link-contact', { defaultValue: 'Contacto' })}
          </a>
        </div>
      </div>
    </footer>
  );
}
